module.exports = __webpack_public_path__ + "img/macaos_scenic_side.a38ed11b.jpg";